// import { Toast } from "vant";
import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import { setCxid } from "../utils/cxid";

/** 解决vue-router重复访问同一个路由地址报错 */
const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error);
};
const routerReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return routerReplace.call(this, location).catch((error) => error);
};

Vue.use(VueRouter);

const routes = [
  {
    path: "/home",
    name: "Home",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "home" */ "../views/home.vue"),
  },
  {
    path: "/sign-up",
    name: "SignUp",
    component: () =>
      import(/* webpackChunkName: "sign-up" */ "../views/sign-up.vue"),
  },
  {
    path: "/sign-up-result",
    name: "SignUpResult",
    component: () =>
      import(
        /* webpackChunkName: "sign-up-result" */ "../views/sign-up-result.vue"
      ),
  },
  {
    path: "/sign-up-detail",
    name: "SignUpDetail",
    component: () =>
      import(
        /* webpackChunkName: "sign-up-detail" */ "../views/sign-up-detail.vue"
      ),
  },
  {
    path: "/rules",
    name: "Rules",
    component: () =>
      import(/* webpackChunkName: "rules" */ "../views/rules.vue"),
  },
  {
    path: "*",
    redirect: () => {
      return { name: "Home" };
    },
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  /**缓存渠道码 */
  if (to.query.cxid) {
    setCxid(to.query.cxid);
  }

  if (!store.state.userInfo.uuid) {
    // Toast.loading({
    //   message: "加载中",
    //   duration: 0,
    // });

    await store.dispatch("initStore");

    // Toast.clear();
  }

  if (
    !store.state.userInfo.uuid &&
    ["SignUp", "SignUpResult", "SignUpDetail"].includes(to.name)
  ) {
    next({ name: "Home" });
    return;
  }

  next();
});

router.afterEach(() => {
  // 解决引入vue-navigation组件后，跳转到新页面不回到顶部问题
  document.body.scrollIntoView();
});

export default router;
